export const LOGIN_ERROR_MESSAGES = {
  usernameRequired: 'Introduzca su nombre de usuario.',
  passwordRequired: 'Introduzca su contraseña.',
  codigoEmpty: 'Por favor, ingrese un código de usuario.',
  BadCredentials:
    'El usuario ingresado no existe, la clave es incorrecta o no está autorizado para ingresar al sistema. Por favor, intente nuevamente.',
  Unauthorized: 'No tiene permiso para realizar esta acción.',
  Locked:
    'La clave del usuario ha sido bloqueada porque superó la cantidad máxima de intentos fallidos. Contacte a su administrador.',
  // TODO: chequear si lo podemos eliminar y que quede el BadCredentials
  // UserNotFound: 'El usuario ingresado no existe. Por favor, intente nuevamente.',
  AdminLocked:
    'Sr. Administrador, le informamos que su usuario se encuentra bloqueado. Para continuar operando, diríjase a su banco emisor y registre nuevamente su dirección de correo.',
  // TODO: rastrear los mensajes de inicio de sesión nuevamente para los distintos tipos de usuario
  SuperAdminLocked:
    'La clave del usuario ha sido bloqueada porque superó la cantidad máxima de intentos fallidos. Por favor, contáctese con Prisma.',
  superAdminLoginError:
    'El usuario ingresado no existe, la clave es incorrecta o no está autorizado para ingresar al sistema. Por favor, contáctese con Prisma.',
};
